import React from 'react';

const FadeInWrapper = ({ children, className = '' }) => {
  return (
    <div className={`animate-fadeIn ${className}`}>
      {children}
    </div>
  );
};

export default FadeInWrapper;